import React from 'react'
import { Container, Grid, Typography, Chip, Divider}from '@material-ui/core'
import useStyles from '../Styles'

export default function Resume(){
    const listSkill = ['Javascript','Java','React','Vue','PHP','MySQL','NodeJS','Material UI','Photoshop','Detail Oriented','Prioritizer','Interpersonal Skill','Problem Solver','Team Player','Multitasker'];
    const useStyle = useStyles();
    return(
        <Container>
            <Grid container wrap ='wrap' spacing={2} className={useStyle.ResumeContainer}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Grid container>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Typography variant='h5'align='center'>Education<hr /></Typography>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Typography variant='h6'>Bachelor: Sekolah Tinggi Teknik Surabaya - Indonesia</Typography>
                            <Typography variant='body2'>Major: Information System</Typography>
                            <Typography variant='subtitle2'>Graduated Cum Laude - 3.52/4.00</Typography>
                            <br/>
                            <Typography variant='h6'>Master: National Cheng Kung University - Taiwan</Typography>
                            <Typography variant='body2'>Major: International Management of Business Administration</Typography>
                            <Typography variant='subtitle2'>Graduated 4.02/4.30</Typography>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Typography variant='h5' align='center'>Skills<hr/></Typography>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            {listSkill.map(value=>(
                                <Chip label={value} color='primary'/>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
                {/* <Divider orientation='vertical' flexItem/> */}
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12} >
                    <Grid container>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Typography variant='h5' align='center'>Work Experiences<hr /></Typography>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Typography variant='h6'>Research Assistant - Sekolah Tinggi Teknik Surabaya, Indonesia</Typography>
                            <Typography variant='body2'>June 2013 - March 2015</Typography>
                            <Typography variant='subtitle2'>
                                <ul>
                                    <li>Application development (iOS/XCode) for goverment and local companies.</li>
                                    <li>Project management for government application development</li>
                                </ul>
                            </Typography>
                            <br/>
                            <Typography variant='h6'>IT Consultant - Golden Lion Inc., Surabaya, Indonesia</Typography>
                            <Typography variant='body2'>April 2014 - December 2015</Typography>
                            <Typography variant='subtitle2'>
                                <ul>
                                    <li>Full web development for client's event</li>
                                    <li>Mediating meeting between client and programmers</li>
                                </ul>
                            </Typography>
                            <br/>
                            <Typography variant='h6'>IT Manager - Pentawira Agraha Sakti, Surabaya, Indonesia</Typography>
                            <Typography variant='body2'>January 2016 - November 2018</Typography>
                            <Typography variant='subtitle2'>
                                <ul>
                                    <li>Educate staff members on optimized usage of Microsoft Offices and several software capabilities</li>
                                    <li>Successfully managed company and subsidiaries on using their hardware and network capabilities effectively and efficiently</li>
                                </ul>
                            </Typography>
                            </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}